import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import './index.css'
import App from './App'
import Home from './pages/Home'
import Search from './pages/Search'
import Item from './pages/Item'
import About from './pages/About'
import Privacy from './pages/Privacy'
import AdminDashboard from './pages/AdminDashboard'
import AdminRoute from './components/AdminRoute'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App/>,
    children: [
      { index: true, element: <Home/> },
      { path: 'search', element: <Search/> },
      { path: 'item/:slug', element: <Item/> },
      { path: 'about', element: <About/> },
      { path: 'privacy', element: <Privacy/> },
      { 
        path: 'admin/*', 
        element: (
          <AdminRoute>
            <AdminDashboard/>
          </AdminRoute>
        )
      }
    ]
  }
])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
)